<mat-form-field>
  <mat-label>{{ fieldLabel }}</mat-label>
  <input
    #input
    type="text"
    matInput
    [formControl]="control()"
    [matAutocomplete]="autocomplete"
    [appMultiValueHotkeys]="mvFieldMenu()"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    (keydown.escape)="onEscapeTypeaheadInput($event)"
  />
  <mat-autocomplete
    #autocomplete="matAutocomplete"
    [class]="`${this.autoCompleteClass()}`"
    (optionSelected)="onSelectionChange()"
    (optionActivated)="onActivateListItem($event)"
  >
    @for (value of filteredListValues$ | async; track value) {
      <mat-option
        [matTooltipDisabled]="value.length <= 16"
        matTooltipShowDelay="1000"
        [matTooltip]="value"
        [value]="value"
      >
        {{ value }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (field().multiValue && mvFieldMenu()) {
    <button
      [disabled]="control().disabled"
      tabIndex="-1"
      mat-icon-button
      type="button"
      matSuffix
      [matMenuTriggerFor]="mvFieldMenu()!.matMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  }
  @if (control().invalid) {
    <mat-error class="ellipsis" [matTooltip]="errorMessage">{{
      errorMessage
    }}</mat-error>
  }
</mat-form-field>
